<template>
  <div>
    <div class="title">Gene annotation</div>
    <!--表格-->
    <table border="1" cellspacing="0">
      <tr>
        <th colspan="3">GO annotation</th>
      </tr>
      <tr>
        <td width="33%">GO_Entry</td>
        <td width="33%">Anno</td>
        <td>Type</td>
      </tr>
      <tr v-for="(item,index) in goInfo" :key="index">
        <td width="33%">{{item.goEntry}}</td>
        <td width="33%">{{item.anno}}</td>
        <td>{{item.type}}</td>
      </tr>
    </table>
    <table border="1" cellspacing="0">
      <tr>
        <th colspan="3">KEGG annotation</th>
      </tr>
      <tr>
        <td width="33%">Target_ID</td>
        <td width="33%">KO_Entry</td>
        <td>KO_Difinition</td>
      </tr>
      <tr v-for="(item,index) in keggInfo" :key="index">
        <td width="33%">{{item.targetId}}</td>
        <td width="33%">{{item.koEntry}}</td>
        <td>{{item.koDefinition}}</td>
      </tr>
    </table>
    <table border="1" cellspacing="0">
      <tr>
        <th colspan="2">InterPro annotation</th>
      </tr>
      <tr>
        <td>IPR_Entry</td>
        <td>IPR_Anno</td>
      </tr>
      <tr v-for="(item,index) in iprInfo" :key="index">
        <td >{{item.iprEntry}}</td>
        <td >{{item.iprAnno}}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      tabData:"",
      goInfo:[],
      keggInfo:[],
      iprInfo:[],
    };
  },
  props: ["id"],
  created() {
    let token=localStorage.getItem("authorization");
      if(token=="" || token==null){
         this.$alert("Login expired, please log in again", "Notice", {
              confirmButtonText: 'Confirm',
              callback: (action) => {
                 that.$router.push("/login");
              },
            });
        return false;
      }
    //console.log(this.id);
    this.getAnnotation(this.id);
  },
  methods: {
    getAnnotation(id) {
      let that = this;
       let token=localStorage.getItem("authorization");
      axios
        .get("/bena/server/gooal/gene/annotation/" + id,{
          headers: { Authorization: token},
        })
        .then(function (response) {
          //console.log(response);
          that.goInfo=response.data.goInfo;
          that.keggInfo=response.data.keggInfo;
          that.iprInfo=response.data.iprInfo;
        })
        .catch(function (error) {
          that.$message.error("失败!");
          //console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.title {
  color: seagreen;
}
table {
  height: 100px;
  margin: 20px 0 40px 0;
  width: 100%;
  text-align: center;
  white-space: nowrap;
}
th {
  background-color: rgb(128, 207, 158);
  color: rgb(17, 30, 34);
}
</style>>